import React from 'react'
import { NavigatedTo } from '../signals'
import { appHistory } from '@core/Utils/routing/history'

export const useNavigationObserver = (): void => {
  React.useEffect(() => {
    const checkForLegacyRouting = () => {
      const hash = window.location.hash

      if (hash && hash.length > 1 && location.pathname === '/') {
        /** Convert legacy hash route to browser routing route
            @todo Remove force when proxy on window.history.replaceState is removed */
        appHistory.replace('/' + hash.replace(/^\/*#?\/*/, ''), { force: true })
      }
    }

    const handleNavChange = () => {
      const path = location.pathname + location.search + location.hash
      NavigatedTo({ url: path })
    }

    checkForLegacyRouting()
    handleNavChange()
    const dispose = appHistory.listen(handleNavChange)
    window.addEventListener('hashchange', checkForLegacyRouting)

    return () => {
      dispose()
      window.removeEventListener('hashchange', checkForLegacyRouting)
    }
  }, [])
}
